import { mapFieldArrToObjSchema } from '../../validation/useValidation';
import * as R from 'ramda';
export const productModel = {
    id: 350,
    name: "تسنیم فی التفسیر القرآن، الجزء 21",
    slug: "تسنیم-فی-التفسیر-القرآن-الجزء-21",
    description: null,
    price: 1570000,
    discounted_price: 1334500,
    discounted_percent: 15,
    product_type: {},
    category: [],
    images: [],
    tags: [],
    attributes: []
};

export const singleProductInit = {
    name: "",
    attributes: [],
    title: "",
};

export const remUnusedPropProduct = R.omit([
    'slug',
    'id',
]);

export const pickerPropProduct = R.pick([
    'name',
    'description',
    'price',
    'discounted_price',
    'discounted_percent',
    'product_type',
    'category',
    'images',
    'tags',
    'attributes'
    //
]);
export const pickerPropProductPatch = R.pick([
    'title',
    'rial_price',
    'rial_discount_price',
    'cent_price',
    'cent_discount_price',
    'language',
    'lessons_file_type',
    'total_lessons',
    'sessions_with_teacher',
    'refund_days',
    'description',
    'base_release_at',
    'base_release_gap',
    'max_allowed_incomplete_exercises',
    'summery',
    'slug',
    //
]);

export const FormProductTypeInit = {
    name: "",
    attributes: [],
    title: "",
};

const productTypeValidationsArr = [
    ['name', 'string'],
    ['attributes', 'array'],
    ['title', 'string'],
];


export const productTypeValidations = mapFieldArrToObjSchema(productTypeValidationsArr);
